import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { filters: { type: Object, default: {} }, view: Number }
  }

  static get targets() {
    return ["clearAll", "content", "loading", "saveSearch", "saveSearchFiltersInput", "saveSearchButton"]
  }

  connect() {
    this._removeEmptyFilterValues()
    this._showHide()
  }

  filter(event) {
    let filtersValue = this.filtersValue

    if (event.detail && event.detail.filters) {
      event.detail.filters.forEach(filter => {
        filtersValue[filter.name] = filter.values
      })
    } else if (event.detail && event.detail.name) {
      filtersValue[event.detail.name] = event.detail.values
    }

    this.filtersValue = filtersValue
    this._removeEmptyFilterValues()
    this.saveSearchFiltersInputTarget.value = JSON.stringify(this.filtersValue)
    this._showHide()
    this._loading()
  }

  _removeEmptyFilterValues() {
    let filtersValue = this.filtersValue

    Object.keys(filtersValue).forEach(key => {
      if (filtersValue[key] === "" || filtersValue[key] === null) {
        delete filtersValue[key]
      } else if (Array.isArray(filtersValue[key]) && filtersValue[key].length === 0) {
        delete filtersValue[key]
      }
    })

    this.filtersValue = filtersValue
  }

  _showHide() {
    let hasFilters = Object.values(this.filtersValue).filter(value => value).length > 0

    if (hasFilters || this.hasViewValue) {
      this.clearAllTarget.classList.remove("d-none")
      this.saveSearchTarget.classList.remove("d-none")
      this.saveSearchButtonTarget.disabled = !hasFilters
    } else {
      this.clearAllTarget.classList.add("d-none")
      this.saveSearchTarget.classList.add("d-none")
    }
  }

  _loading() {
    this.contentTarget.classList.add("d-none")
    this.loadingTarget.classList.remove("d-none")
  }
}
